export default __webpack_public_path__ + "static/media/vaibhav.7498db8d.png";